// extracted by mini-css-extract-plugin
module.exports = {"button":"IconButton_button__10Jyt","tooltip":"IconButton_tooltip__3H8jm"};